import React, { PureComponent } from 'react';
import _get from 'lodash/get';

// import Link from 'gatsby-link';

class IndexPage extends PureComponent {
  constructor({ data }) {
    super();
    this.items = _get(data, 'allItems.edges', []);
    console.log(this.items);
  }

  renderItem(itemData) {
    const { node: item } = itemData;
    return (
      <article key={item.id} className="bpp-item">
        <figure>
        &lt;image goes here meow /&gt;
        </figure>
        <figcaption>
          <h3>{item.title}</h3>
          <p>{item.caption}</p>
        </figcaption>
      </article>
    );
  }

  maybeRenderItems() {
    if (this.items.length) {
      return (
        this.items.map((itemData) => {
          return this.renderItem(itemData);
        })
      );
    }
  }

  render() {
    return (
      <div className="home-component">
        {this.maybeRenderItems()}
      </div>
    );
  }
}

export const query = graphql`
  query ItemQuery {
    allItems {
      edges {
        node {
          id
          approved
          caption
          title
          tag
        }
      }
    }
  }
`;

export default IndexPage;


// const IndexPage = () => (
//   <div>
//     <h1>Hi people</h1>
//     <p>Welcome to your new Gatsby site.</p>
//     <p>Now go build something great.</p>
//     <Link to="/page-2/">Go to page 2</Link>
//   </div>
// )


// WEBPACK FOOTER //
// ./src/pages/index.js